import { MethodTypeRepository } from '@telespot/domain';

export interface ICountMethodTypesByAssetTypeQuery {
  /**
   * Counts method types referencing the given asset type.
   * Repository errors propagate so the caller can update its error state.
   */
  execute(assetTypeId: string): Promise<number>;
}

export class CountMethodTypesByAssetTypeQuery implements ICountMethodTypesByAssetTypeQuery {
  constructor(private readonly methodTypeRepository: MethodTypeRepository) {}

  public async execute(assetTypeId: string): Promise<number> {
    return this.methodTypeRepository.countByAssetType(assetTypeId);
  }
}
